import React, { Component } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { GOOGLE } from 'common/consts/common';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';
import noop from 'lodash/noop';

import { isOnMobile } from 'utils/device-utils';

import markerImgInactive from 'common/images/off.svg';
import markerImgActive from 'common/images/on.svg';

import defaultMapOptions from './defaultMapOptions.json';

const markerActive = {
  url: markerImgActive,
  scaledSize: { width: 50, height: 62 }
};

const markerInactive = {
  url: markerImgInactive,
  scaledSize: { width: 50, height: 62 }
};

const RenderMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultCenter={props.defaultMapPosition}
      defaultZoom={props.defaultZoom}
      defaultOptions={{ styles: defaultMapOptions }}
      onTilesLoaded={() => props.setMapLoaded()}
    >
      {props.markers}
    </GoogleMap>
  ))
);

export default class Map extends Component {
  static propTypes = {
    offices: MobxPropTypes.observableArray,
    activeDepartment: PropTypes.object,
    onClick: PropTypes.func
  };

  static defaultProps = {
    offices: [],
    activeDepartment: {},
    onClick: noop
  };

  state = {
    isMobile: isOnMobile()
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  renderMarkers() {
    const { offices, activeDepartment, onClick } = this.props;
    return offices.map(item => {
      const isActive = activeDepartment.id === item.id;
      const onClickHandler = isActive ? noop : onClick;

      if (!item.longitude || !item.latitude) {
        return null;
      }

      return (
        <Marker
          key={item.id}
          position={{ lat: item.latitude, lng: item.longitude }}
          icon={isActive ? markerActive : markerInactive}
          onClick={() => onClickHandler(item)}
        />
      );
    });
  }

  render() {
    const defaultMapPosition = this.state.isMobile
      ? { lat: 52.6991, lng: 10.235 }
      : { lat: 52.6991, lng: 19.6933 };
    const defaultZoom = 4.15;
    const mapLoaded = this.props.mapLoaded;

    return (
      <div ref={this.props.mapRef}>
        <RenderMap
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${
            GOOGLE.MAP_API_KEY
          }`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div
              style={{
                height: `700px`,
                width: '100%',
                margin: '0 auto',
                visibility: mapLoaded ? 'visible' : 'hidden',
                position: mapLoaded ? 'static' : 'absolute'
              }}
            />
          }
          mapElement={<div style={{ height: `100%` }} />}
          defaultMapPosition={defaultMapPosition}
          defaultZoom={defaultZoom}
          markers={this.renderMarkers()}
          setMapLoaded={this.props.setMapLoaded}
        />
      </div>
    );
  }

  @Bind()
  @Debounce(200)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Components/Map/Map.js